import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-page py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h4 className="font-heading text-3xl md:text-4xl text-background-50 mb-4">
              韩漫头条
            </h4>
            <p className="text-background-400 text-sm leading-relaxed mb-8 max-w-md">
              致力于为全球华语用户提供最新、最全的韩国漫画在线阅读服务。我们坚持免费、无删减、高品质的原则，让每一位韩漫爱好者都能享受到极致的阅读体验。
            </p>
            <div className="flex flex-col sm:flex-row gap-2 max-w-sm">
              <input
                type="email"
                placeholder="输入邮箱，订阅更新通知"
                className="flex-1 bg-transparent border-b border-background-600 text-background-200 text-sm py-2 px-1 outline-none focus:border-primary-400 transition-colors placeholder:text-background-500"
              />
              <button className="bg-background-50 text-foreground-950 text-sm font-medium px-5 py-2 rounded-full whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors">
                订阅 <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </div>
          </div>

          <div className="md:col-span-2">
            <h5 className="text-background-50 text-sm font-semibold mb-4">快速导航</h5>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: "热门推荐", href: "/" },
                { label: "最新更新", href: "/" },
                { label: "恋爱漫画", href: "/category/lianai" },
                { label: "动作漫画", href: "/category/dongzuo" },
                { label: "奇幻漫画", href: "/category/qihuan" },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-background-400 text-sm hover:text-background-100 transition-colors cursor-pointer border-b border-transparent hover:border-background-500"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-5">
            <h5 className="text-background-50 text-sm font-semibold mb-4">联系我们</h5>
            <div className="flex flex-col gap-3 text-sm text-background-400">
              <p>
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:+8610-8888-6666" className="hover:text-background-100 transition-colors cursor-pointer">+86 10-8888-6666</a>
              </p>
              <p>
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:hello@uqdww.cn" className="hover:text-background-100 transition-colors cursor-pointer">hello@uqdww.cn</a>
              </p>
            </div>
            <h5 className="text-background-50 text-sm font-semibold mt-6 mb-3">公司地址</h5>
            <p className="text-background-400 text-sm leading-relaxed">
              北京市朝阳区望京SOHO<br />
              T1栋B座1806室
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/50">
        <div className="container-page flex flex-col sm:flex-row items-center justify-between py-6 gap-4">
          <div className="flex items-center gap-6">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer text-sm border-b border-transparent hover:border-background-500" rel="nofollow">微博</a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer text-sm border-b border-transparent hover:border-background-500" rel="nofollow">微信公众号</a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer text-sm border-b border-transparent hover:border-background-500" rel="nofollow">B站</a>
          </div>
          <p className="text-background-500 text-xs">
            &copy; 2026 韩漫头条 HanManTouTiao.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer text-xs border-b border-transparent hover:border-background-500">关于我们</Link>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer text-xs border-b border-transparent hover:border-background-500" rel="nofollow">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}